import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { apiError } from "@/lib/campus";

const field = "flex-1 min-w-0 bg-[#0B0E14] border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:border-amber-500 disabled:opacity-60";

export const ContactVerify = ({ email, setEmail, verified, setVerified }) => {
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); ok(); } catch (err) { toast.error(apiError(err, "Something went wrong")); } finally { setBusy(false); }
  };
  const start = () => run(() => api.post("/instructor/verify-email/start", { email }), () => { setSent(true); toast.success("We sent a 6-digit code"); });
  const confirm = () => run(() => api.post("/instructor/verify-email/confirm", { email, code }), () => { setVerified(true); toast.success("Email verified"); });

  return (
    <div>
      <label className="block text-xs font-semibold text-slate-300 mb-1">Student contact email (verified — students email you questions here)</label>
      <div className="flex gap-2">
        <input data-testid="builder-contact-email" type="email" disabled={verified} placeholder="you@example.com" value={email}
          onChange={(e) => setEmail(e.target.value)} className={field} />
        {!verified && (
          <button type="button" data-testid="builder-verify-start" onClick={start} disabled={busy || !email}
            className="px-3 rounded-lg bg-white/5 border border-white/10 text-amber-300 text-xs font-semibold hover:bg-white/10 whitespace-nowrap disabled:opacity-50">
            {sent ? "Resend" : "Send code"}
          </button>
        )}
      </div>
      {verified ? (
        <p className="text-xs text-emerald-400 mt-1.5 flex items-center gap-1" data-testid="builder-email-verified"><CheckCircle2 className="h-3.5 w-3.5" /> Verified</p>
      ) : sent && (
        <div className="flex gap-2 mt-2">
          <input data-testid="builder-verify-code" placeholder="6-digit code" value={code} onChange={(e) => setCode(e.target.value)} className={field} />
          <button type="button" data-testid="builder-verify-confirm" onClick={confirm} disabled={busy}
            className="px-4 rounded-lg bg-amber-500 text-slate-950 text-xs font-bold hover:bg-amber-400">Verify</button>
        </div>
      )}
    </div>
  );
};
